import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';
import { ContentRenderer, Popover as TinyPopover, PopoverProps as TinyPopoverProps } from 'react-tiny-popover';

const PopoverContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)',
  border: `1px solid ${theme.palette.background.active}`,
  color: theme.palette.text.primary,
}));

interface AppPopoverProps {
  trigger: ReactElement;
  containerWidth?: number;
  isOpen?: boolean;
  children: ReactElement | ContentRenderer;
  onClickOutside?: () => void;
}

type PopoverProps = Omit<TinyPopoverProps, 'content' | 'trigger'> & AppPopoverProps;

export default function Popover({
  trigger,
  containerWidth = 240,
  isOpen = false,
  children,
  onClickOutside,
  ...restProps
}: PopoverProps) {
  return (
    <TinyPopover
      {...restProps}
      isOpen={isOpen}
      containerStyle={{ zIndex: '1000' }}
      onClickOutside={onClickOutside}
      positions={['bottom', 'top', 'right', 'left']}
      align="start"
      content={
        isOpen ? <PopoverContentContainer sx={{ width: containerWidth }}>{children}</PopoverContentContainer> : <></>
      }
      padding={8}
      reposition
    >
      <div>{trigger}</div>
    </TinyPopover>
  );
}
